import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { WEEKDAYS_SHORT } from './constants';

function WeekDayHeader() {
  return WEEKDAYS_SHORT.map(h => (
    <Typography
      key={h.value}
      variant="caption"
      color="text.secondary"
      sx={{ textAlign: 'center', py: 0.5 }}>
      <FormattedMessage
        id={h?.label?.toUpperCase()}
        defaultMessage={h?.label}
      />
    </Typography>
  ));
}

export default WeekDayHeader;
